import { type DatePreset } from '../types';
import {
  addDays,
  addHours,
  endOfDay,
  nextSaturday,
  nextSunday,
  startOfDay,
  startOfWeek,
  endOfWeek,
} from 'date-fns';

export const RelativeDatePresents = [
  {
    id: 'today',
    label: 'Today',
    from: startOfDay(new Date()),
    to: endOfDay(new Date()),
    shortcut: 'd', // day
  },
  {
    id: 'yesterday',
    label: 'Yesterday',
    from: startOfDay(addDays(new Date(), -1)),
    to: endOfDay(addDays(new Date(), -1)),
    shortcut: 'y',
  },
  {
    id: 'last-hour',
    label: 'Last hour',
    from: addHours(new Date(), -1),
    to: new Date(),
    shortcut: 'h',
  },
  {
    id: 'last-7-days',
    label: 'Last 7 days',
    from: startOfDay(addDays(new Date(), -7)),
    to: endOfDay(new Date()),
    shortcut: 'w',
  },
  {
    id: 'last-14-days',
    label: 'Last 14 days',
    from: startOfDay(addDays(new Date(), -14)),
    to: endOfDay(new Date()),
    shortcut: 'b', // bi-weekly
  },
  {
    id: 'last-30-days',
    label: 'Last 30 days',
    from: startOfDay(addDays(new Date(), -30)),
    to: endOfDay(new Date()),
    shortcut: 'm',
  },
  {
    id: 'tomorrow',
    label: 'Tomorrow',
    from: startOfDay(addDays(new Date(), 1)),
    to: endOfDay(addDays(new Date(), 1)),
    shortcut: 't',
  },
  {
    id: 'this-week',
    label: 'This week',
    from: startOfWeek(new Date(), { weekStartsOn: 1 }),
    to: endOfWeek(new Date(), { weekStartsOn: 1 }),
    shortcut: 'W',
  },
  {
    id: 'this-weekend',
    label: 'This weekend',
    from: startOfDay(nextSaturday(new Date())),
    to: endOfDay(nextSunday(new Date())),
    shortcut: 'e',
  },
  {
    id: 'next-7-days',
    label: 'Next 7 days',
    from: startOfDay(new Date()),
    to: endOfDay(addDays(new Date(), 7)),
    shortcut: 'n',
  },
  {
    id: 'next-30-days',
    label: 'Next 30 days',
    from: startOfDay(new Date()),
    to: endOfDay(addDays(new Date(), 30)),
    shortcut: 'N',
  },
] satisfies DatePreset[];
